module.exports = __webpack_public_path__ + "static/GooglePlayWhite-bbb80fe4d3242ac13e47afbbf9fb05fa.svg";